import { cfetch } from '@confluence/network';

import { REFERRAL_LINK } from '../pageCoverPictureConstants';

export type UnsplashPhoto = {
	artistName: string;
	artistUrl: string;
	fullSizeImageUrl: string;
	smallSizeImageUrl: string;
	description: string;
	downloadLink: string;
};

export async function getUnsplashPhotos(
	queryWord: string,
	pageNumber: number,
	isPageTitleComponent?: boolean,
) {
	return cfetch(
		`/wiki/rest/internals/1.0/unsplash/search?query=${queryWord}&pageNumber=${pageNumber}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		},
	)
		.then((response) => response.json())
		.then((responseData) => {
			const unsplashResults = responseData.results ?? [];
			return unsplashResults.map((result) => ({
				artistName: result.user.name,
				artistUrl: result.user.links.html + REFERRAL_LINK,
				fullSizeImageUrl: isPageTitleComponent ? result.urls.full : result.urls.regular,
				smallSizeImageUrl: result.urls.thumb,
				description: result.description,
				downloadLink: result.links.download_location,
			}));
		});
}

export function downloadUnsplashPhoto(downloadLink: string) {
	void cfetch(`/wiki/rest/internals/1.0/unsplash/download`, {
		method: 'POST',
		body: JSON.stringify({
			downloadLink,
		}),
		headers: {
			'Content-Type': 'application/json',
		},
	});
}
